import { Box, Typography } from "@mui/material";
import { getStyles } from "./Hero.styles";

const Hero = () => {
  const styles = getStyles();
  const titleImage = { src: "/assets/images/doneaza-title.svg", alt: "Donează o carte și fă din vis realitate" };
  return (
    <Box sx={styles.heroContainer}>
      <Box sx={styles.heroSection}>
        <Box sx={styles.heroImage}>
          <img src="/assets/images/landing-illustration.svg" alt="hero-image" />
        </Box>
        <Box sx={styles.heroDescription}>
          <Box sx={{
            width: "100%"
          }}>
            <img
                  src={titleImage.src}
                  alt={titleImage.alt}
                  loading="lazy"
                  draggable={false}
                />
          </Box>
          <Typography variant="h4" component="p">
            <b>Colectarea de cărți s-a încheiat.</b>
          </Typography>
          <Typography variant="h4" component="p">
            Împreună, am dus lectura mai aproape de copiii care aveau nevoie de ea. Vă mulțumim pentru implicare și susținere.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;
